import BaseModel from './BaseModel'

export default class InventoryServiceVideo extends BaseModel {
  // ... InventoryServiceVideo-specific methods or overrides ...
}
